import { Component, input, TemplateRef, ContentChild } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-stepper-step',
  standalone: true,
  imports: [CommonModule],
  template: '<ng-content></ng-content>',
  styles: []
})
export class StepperStepComponent {
  id = input<string>('');
  title = input<string>('');
  description = input<string>('');
  completed = input<boolean>(false);

  @ContentChild('stepContent') contentTemplate?: TemplateRef<any>;
}

